import React from 'react';
import { Divider, Grid2 as Grid } from '@mui/material';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import HeaderSection from 'Feature/Arrears/components/ArrearsInquiryPage/ui/commonInformationSection/HeaderSection';
import InstitutionSection from 'Feature/Arrears/components/ArrearsInquiryPage/ui/commonInformationSection/InstitutionSection';
import OpenClosedArrearsInfo from 'Feature/Arrears/components/ArrearsInquiryPage/ui/commonInformationSection/OpenClosedArrearsInfo';
import PropertyInfos from 'Feature/Arrears/components/ArrearsInquiryPage/ui/commonInformationSection/PropertyInfos';

const CommonInformationSection = ({ arrears }: { arrears: Arrears }) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        flexGrow: 1,
        background: 'linear-gradient(180deg, #FFF 0%, #F8F9F9 100%)',
        padding: '0px 32px 20px 32px',
        margin: '0px -32px'
      }}
    >
      <Grid size={12}>
        <HeaderSection arrears={arrears} />
      </Grid>
      <Grid size={7} paddingLeft={{ sm: '5px', md: '72px' }}>
        <PropertyInfos arrears={arrears} />
      </Grid>
      <Grid size={1}>
        <Divider orientation="vertical" />
      </Grid>
      <Grid
        size={4}
        paddingLeft={{ sm: '5px', md: '72px' }}
        paddingRight={{ sm: '5px', md: '20px' }}
      >
        <InstitutionSection arrears={arrears} />
      </Grid>
      <Grid size={12} paddingLeft={{ sm: '5px', md: '72px' }}>
        <OpenClosedArrearsInfo arrears={arrears} />
      </Grid>
    </Grid>
  );
};

export default CommonInformationSection;
